import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import optional from '@nullvoxpopuli/ember-composable-helpers/helpers/optional';
import { ref } from 'ember-ref-bucket';
import createRef from 'ember-ref-bucket/modifiers/create-ref';
import setBodyClass from 'ember-set-body-class/helpers/set-body-class';
import BvScrollLock from 'volta/components/bv-scroll-lock';
import config from 'volta/config/environment';
import classNames from 'volta/helpers/class-names';

interface BvBackdropSignature {
  Args: {
    onClick?: () => void;
    onTransitionEnd?: () => void;
    belowAppHeader?: boolean;
    hidden?: boolean;
    blurred?: boolean;
    transparent?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export const BvBodyHasBackdropClassName = 'bv-body--has-backdrop';

export default class BvBackdropComponent extends Component<BvBackdropSignature> {
  destinationElement = config.APP.rootElement
    ? document.querySelector(config.APP.rootElement)!
    : document.body;
  lastMouseDownElement?: HTMLElement;
  BvBodyHasBackdropClassName = BvBodyHasBackdropClassName;

  @ref('backdropElement')
  backdropElement?: HTMLElement;

  @action
  handleMouseDown(e: MouseEvent) {
    this.lastMouseDownElement = e.target as HTMLElement;
  }

  @action
  handleMouseUp(_e: MouseEvent) {
    if (this.lastMouseDownElement === this.backdropElement) {
      this.args.onClick?.();
    }
  }

  <template>
    {{setBodyClass this.BvBodyHasBackdropClassName}}
    {{#in-element this.destinationElement insertBefore=null}}
      <BvScrollLock />
      {{! template-lint-disable no-invalid-interactive }}
      {{! template-lint-disable no-pointer-down-event-binding }}
      <div
        class={{classNames
          'bv-backdrop'
          (if @belowAppHeader 'bv-backdrop--below-header')
          (if @transparent 'bv-backdrop--transparent')
          (if @hidden 'bv-backdrop--hidden')
          (if @blurred 'bv-backdrop--blurred')
        }}
        ...attributes
        {{on 'transitionend' (optional @onTransitionEnd)}}
        {{on 'mousedown' this.handleMouseDown}}
        {{on 'mouseup' this.handleMouseUp}}
        {{createRef 'backdropElement' bucket=this}}
      >
        {{yield}}
      </div>
    {{/in-element}}
  </template>
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvBackdrop: typeof BvBackdropComponent;
    'bv-backdrop': typeof BvBackdropComponent;
  }
}
